import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { PrivateRoute } from "../components/Routing";
import Dashboard from '../pages/Dashboard'
import Auth from '../pages/Auth'
import Layout from "../components/Layout";
import Servers from '../pages/Servers'
import GukServers from "../pages/GukServers";


export default function Routing() {

  return (
    <BrowserRouter>
      <Routes>
        <Route path='/auth' element={<Auth />} />
        <Route element={<PrivateRoute />}>
          <Route path='/' element={<Layout />}>
            <Route index element={<Navigate to='/dashboard' />} />
            <Route path='dashboard' element={<Dashboard.Main />}>
              <Route path='servers' element={<Dashboard.Servers />} />
              <Route path='backup' element={<Dashboard.Backup />} />
              <Route path='exchange' element={<Dashboard.Exchange />} />
              <Route path='fileexchange' element={<Dashboard.Fileexchange />} />
            </Route>
            <Route path='servers' element={<Servers />} />
            <Route path='guk_servers' element={<GukServers />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  )
}